import React, { useEffect, useState } from "react";
import { mergeDecrypted } from "../../utils/decrypt";

import {
  Table,
  Button,
  Input,
  Space,
  Typography,
  Alert,
  Row,
  Col,
  Card,
  Modal,
  Tag,
  message,
  Tooltip,
} from "antd";
import { Search, Upload, Eye, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";

const { Title, Text } = Typography;

const Shipments = () => {
  const navigate = useNavigate();
  const { request } = useRequest();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchText, setSearchText] = useState("");
  const [summary, setSummary] = useState(null);
  const [selectedShipment, setSelectedShipment] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const normalizePayload = (data) => {
    const payload = data?.data ?? data;
    if (Array.isArray(payload)) return payload;
    return payload?.orders ?? payload?.results ?? payload?.data ?? [];
  };

  const getShipmentDate = (order) => {
    return (
      order.shipment_date ||
      order.shipped_at ||
      order.shippedAt ||
      order.updated_at ||
      order.created_at ||
      "-"
    );
  };

  const getOrderDate = (order) => {
    return order.created_at || order.order_date || order.date || "-";
  };

  const getShipmentAddress = (order) => {
    const parts = [
      order.shipping_address_line1,
      order.shipping_address_line2,
      order.shipping_city,
      order.shipping_state,
      order.shipping_country,
      order.shipping_zipcode,
    ].filter(Boolean);

    return parts.join(", ") || order.location || "N/A";
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "-") return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "delivered":
        return "#10b981";
      case "shipped":
        return "#3b82f6";
      case "processing":
        return "#f59e0b";
      case "pending":
        return "#94a3b8";
      case "cancelled":
        return "#ef4444";
      default:
        return "#94a3b8";
    }
  };

  const getStatusText = (status) => {
    return status?.charAt(0).toUpperCase() + status?.slice(1) || "Processing";
  };

  useEffect(() => {
    fetchShipments();
  }, []);

  // const fetchShipments = () => {

  //     setLoading(true);
  //     request({
  //         url: apiPath.orders,
  //         method: "GET",
  //         onSuccess: (response) => {
  //             const orders = normalizePayload(response);

  //             // Calculate summary statistics
  //             const totalShipments = orders.length;
  //             const totalItemsShipped = orders.reduce((sum, order) => {
  //                 const items = order.items ?? order.order_items ?? [];
  //                 return sum + items.reduce((itemSum, item) => itemSum + (Number(item.quantity ?? item.qty ?? 1) || 1), 0);
  //             }, 0);

  //             // Count shipments by status
  //             const shippedCount = orders.filter(order =>
  //                 order.status?.toLowerCase() === 'shipped' ||
  //                 order.shipment_status?.toLowerCase() === 'shipped'
  //             ).length;

  //             const deliveredCount = orders.filter(order =>
  //                 order.status?.toLowerCase() === 'delivered' ||
  //                 order.shipment_status?.toLowerCase() === 'delivered'
  //             ).length;

  //             const processingCount = orders.filter(order =>
  //                 order.status?.toLowerCase() === 'processing' ||
  //                 order.shipment_status?.toLowerCase() === 'processing' ||
  //                 (!order.status && !order.shipment_status)
  //             ).length;

  //             setSummary({
  //                 total_shipments: totalShipments,
  //                 total_items: totalItemsShipped,
  //                 shipped: shippedCount,
  //                 delivered: deliveredCount,
  //                 processing: processingCount
  //             });

  //             const rows = orders.map((order, index) => ({
  //                 key: order.id ?? order.order_number ?? index,
  //                 originalIndex: index,
  //                 id: order.id ?? order.order_number ?? index + 1,
  //                 orderId: order.order_number ?? order.id ?? `#${index + 1}`,
  //                 quantity: (order.items ?? order.order_items ?? []).reduce((sum, item) => sum + (Number(item.quantity ?? item.qty ?? 1) || 1), 0) || 1,
  //                 inventorySource: order.channel || order.source || order.payment_method || "Default",
  //                 shipmentTo: order.customer_name || order.user?.name || order.customer?.name || "Unknown",
  //                 address: getShipmentAddress(order),
  //                 orderDate: formatDate(getOrderDate(order)),
  //                 shipmentDate: formatDate(getShipmentDate(order)),
  //                 status: order.shipment_status || order.status || "processing",
  //                 email: order.customer_email || order.user?.email || "-",
  //                 phone: order.customer_phone || order.user?.phone || "-",
  //                 items: order.items ?? order.order_items ?? [],
  //                 shippingAddress: {
  //                     line1: order.shipping_address_line1,
  //                     line2: order.shipping_address_line2,
  //                     city: order.shipping_city,
  //                     state: order.shipping_state,
  //                     country: order.shipping_country,
  //                     zipcode: order.shipping_zipcode
  //                 },
  //                 trackingNumber: order.tracking_number || order.trackingNumber || "-",
  //                 carrier: order.carrier || order.shipping_carrier || "-"
  //             }));
  //             setTableData(rows);

  //             // Update pagination total
  //             setPagination(prev => ({
  //                 ...prev,
  //                 total: rows.length,
  //                 current: 1
  //             }));

  //             if (!rows.length) {
  //                 setErrorMessage("No shipments found.");
  //             }
  //             setLoading(false);
  //         },
  //         onError: (err) => {
  //             console.error("Shipments fetch error:", err);
  //             setErrorMessage(err?.response?.data?.message || err?.message || "Failed to load shipments.");
  //             setLoading(false);
  //         },
  //     });
  // };

  const fetchShipments = () => {
    setLoading(true);
    request({
      url: apiPath.orders,
      method: "GET",
      onSuccess: async (response) => {
        const rawOrders = normalizePayload(response);
        console.log(rawOrders);
        const orders = await Promise.all(
          rawOrders.map(async (order) => {
            let merged = order.secure
              ? await mergeDecrypted(order).catch((err) => {
                  console.error(`Failed to decrypt order id=${order.id}:`, err);
                  return order;
                })
              : order;

            if (merged.user?.secure) {
              const decryptedUser = await mergeDecrypted(merged.user).catch(
                (err) => {
                  console.error(
                    `Failed to decrypt user for order id=${order.id}:`,
                    err,
                  );
                  return merged.user;
                },
              );
              merged = { ...merged, user: decryptedUser };
            }

            return merged;
          }),
        );

        // Calculate summary statistics
        const totalShipments = orders.length;
        const totalItemsShipped = orders.reduce((sum, order) => {
          const items = order.items ?? order.order_items ?? [];
          return (
            sum +
            items.reduce(
              (itemSum, item) =>
                itemSum + (Number(item.quantity ?? item.qty ?? 1) || 1),
              0,
            )
          );
        }, 0);

        const shippedCount = orders.filter(
          (order) =>
            order.status?.toLowerCase() === "shipped" ||
            order.shipment_status?.toLowerCase() === "shipped",
        ).length;

        const deliveredCount = orders.filter(
          (order) =>
            order.status?.toLowerCase() === "delivered" ||
            order.shipment_status?.toLowerCase() === "delivered",
        ).length;

        const processingCount = orders.filter(
          (order) =>
            order.status?.toLowerCase() === "processing" ||
            order.shipment_status?.toLowerCase() === "processing" ||
            (!order.status && !order.shipment_status),
        ).length;

        setSummary({
          total_shipments: totalShipments,
          total_items: totalItemsShipped,
          shipped: shippedCount,
          delivered: deliveredCount,
          processing: processingCount,
        });

        const rows = orders.map((order, index) => ({
          key: order.id ?? order.order_number ?? index,
          originalIndex: index,
          id: order.id ?? order.order_number ?? index + 1,
          orderId: order.order_number ?? order.id ?? `#${index + 1}`,
          quantity:
            (order.items ?? order.order_items ?? []).reduce(
              (sum, item) =>
                sum + (Number(item.quantity ?? item.qty ?? 1) || 1),
              0,
            ) || 1,
          inventorySource:
            order.channel || order.source || order.payment_method || "Default",
          shipmentTo:
            order.customer_name ||
            order.user?.name ||
            order.customer?.name ||
            "Unknown",
          address: getShipmentAddress(order),
          orderDate: formatDate(getOrderDate(order)),
          shipmentDate: formatDate(getShipmentDate(order)),
          status: order.shipment_status || order.status || "processing",
          email: order.customer_email || order.user?.email || "-",
          phone: order.customer_phone || order.user?.phone || "-",
          items: order.items ?? order.order_items ?? [],
          shippingAddress: {
            line1: order.shipping_address_line1,
            line2: order.shipping_address_line2,
            city: order.shipping_city,
            state: order.shipping_state,
            country: order.shipping_country,
            zipcode: order.shipping_zipcode,
          },
          trackingNumber: order.tracking_number || order.trackingNumber || "-",
          carrier: order.carrier || order.shipping_carrier || "-",
        }));
        console.log(rows);

        setTableData(rows);

        setPagination((prev) => ({
          ...prev,
          total: rows.length,
          current: 1,
        }));

        if (!rows.length) {
          setErrorMessage("No shipments found.");
        }
        setLoading(false);
      },
      onError: (err) => {
        console.error("Shipments fetch error:", err);
        setErrorMessage(
          err?.response?.data?.message ||
            err?.message ||
            "Failed to load shipments.",
        );
        setLoading(false);
      },
    });
  };
  const handleViewDetails = (record) => {
    setSelectedShipment(record);
    setModalVisible(true);
  };

  // Filter shipments based on search
  const filteredData = searchText
    ? tableData.filter(
        (shipment) =>
          shipment.orderId?.toLowerCase().includes(searchText.toLowerCase()) ||
          shipment.shipmentTo
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          shipment.address?.toLowerCase().includes(searchText.toLowerCase()) ||
          shipment.orderId?.includes(searchText),
      )
    : tableData;

  // Update pagination total when filter changes
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      total: filteredData.length,
      current: 1,
    }));
  }, [searchText]);

  // Get current page data
  const getCurrentPageData = () => {
    const start = (pagination.current - 1) * pagination.pageSize;
    const end = start + pagination.pageSize;
    return filteredData.slice(start, end).map((item, index) => ({
      ...item,
      srNo: start + index + 1,
    }));
  };

  const handleTableChange = (newPagination) => {
    setPagination({
      current: newPagination.current,
      pageSize: newPagination.pageSize,
      total: filteredData.length,
    });
  };

  // Export to CSV with improved formatting
  const handleExport = () => {
    const exportData = filteredData.map((shipment, index) => ({
      "SR No.": index + 1,
      "Order ID": shipment.orderId,
      "Customer Name": shipment.shipmentTo,
      Email: shipment.email,
      Phone: shipment.phone !== "-" ? shipment.phone : "",
      Address: shipment.address,
      "Total Quantity": shipment.quantity,
      "Inventory Source": shipment.inventorySource,
      "Order Date": shipment.orderDate,
      "Shipment Date": shipment.shipmentDate,
      Status: getStatusText(shipment.status),
      "Tracking Number":
        shipment.trackingNumber !== "-" ? shipment.trackingNumber : "",
      Carrier: shipment.carrier !== "-" ? shipment.carrier : "",
    }));

    const csv = convertToCSV(exportData);
    // Add BOM for UTF-8 to handle special characters
    const blob = new Blob(["\uFEFF" + csv], {
      type: "text/csv;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    const timestamp = new Date()
      .toISOString()
      .replace(/[:.]/g, "-")
      .slice(0, 19);
    a.href = url;
    a.download = `shipments_export_${timestamp}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);

    message.success(`${exportData.length} shipments exported successfully`);
  };

  const convertToCSV = (data) => {
    if (!data || data.length === 0) return "";

    const headers = Object.keys(data[0]);
    const csvRows = [];

    csvRows.push(headers.join(","));

    for (const row of data) {
      const values = headers.map((header) => {
        let value = row[header] || "";
        // Convert to string and escape quotes
        value = String(value);
        if (
          value.includes(",") ||
          value.includes('"') ||
          value.includes("\n")
        ) {
          value = `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      });
      csvRows.push(values.join(","));
    }

    return csvRows.join("\n");
  };

  const columns = [
    {
      title: "SR No.",
      dataIndex: "srNo",
      key: "srNo",
      width: 70,
      fixed: "left",
      render: (text) => (
        <Text style={{ color: "#64748b", fontWeight: 500 }}>{text}</Text>
      ),
    },
    {
      title: "Order ID",
      dataIndex: "orderId",
      key: "orderId",
      width: 200,
      fixed: "left",
      render: (text, record) => (
        <div>
          <Text strong style={{ color: "#0f172a", fontSize: "13px" }}>
            {text}
          </Text>
          <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "2px" }}>
            ID: {record.id}
          </div>
        </div>
      ),
    },
    {
      title: "Customer",
      dataIndex: "shipmentTo",
      key: "shipmentTo",
      width: 180,
      render: (text, record) => (
        <div>
          <Text style={{ color: "#334155", fontSize: "13px", fontWeight: 500 }}>
            {text}
          </Text>
          <div style={{ fontSize: "12px", color: "#64748b" }}>
            {record.email}
          </div>
        </div>
      ),
    },
    {
      title: "Total Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: 120,
      align: "center",
      render: (text) => (
        <div
          style={{
            background: "#f1f5f9",
            borderRadius: "20px",
            padding: "2px 10px",
            display: "inline-block",
            fontSize: "13px",
            fontWeight: 500,
            color: "#475569",
          }}
        >
          {text} item{text !== 1 ? "s" : ""}
        </div>
      ),
    },
    {
      title: "Inventory Source",
      dataIndex: "inventorySource",
      key: "inventorySource",
      width: 150,
      render: (text) => (
        <Tag color="purple" style={{ borderRadius: "4px" }}>
          {text}
        </Tag>
      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      width: 250,
      ellipsis: true,
      render: (text) => (
        <Text style={{ color: "#64748b", fontSize: "12px" }} ellipsis>
          {text}
        </Text>
      ),
    },
    {
      title: "Order Date",
      dataIndex: "orderDate",
      key: "orderDate",
      width: 160,
      render: (text) => (
        <Text style={{ color: "#64748b", fontSize: "13px" }}>{text}</Text>
      ),
    },
    {
      title: "Shipment Date",
      dataIndex: "shipmentDate",
      key: "shipmentDate",
      width: 160,
      render: (text) => (
        <Text style={{ color: "#64748b", fontSize: "13px" }}>{text}</Text>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 110,
      render: (status) => (
        <Tag
          style={{
            borderRadius: "12px",
            border: "none",
            fontWeight: 500,
            padding: "2px 12px",
            background: getStatusColor(status),
            color: "#fff",
            fontSize: "12px",
          }}
        >
          {getStatusText(status)}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "actions",
      width: 80,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Tooltip title="View Details">
          <Button
            type="text"
            icon={<Eye size={18} style={{ color: "#2563eb" }} />}
            onClick={(e) => {
              e.stopPropagation();
              handleViewDetails(record);
            }}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div
      className="shipments-container"
      style={{
        padding: "24px",
        background: "#fff",
        minHeight: "100vh",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <Title
          level={3}
          style={{ margin: 0, color: "#0f172a", fontWeight: 700 }}
        >
          Shipments
        </Title>
        <Button
          icon={<Upload size={16} />}
          onClick={handleExport}
          style={{
            display: "flex",
            alignItems: "center",
            borderRadius: "6px",
            color: "#64748b",
            fontWeight: 500,
          }}
          disabled={filteredData.length === 0}
        >
          Export {filteredData.length > 0 && `(${filteredData.length})`}
        </Button>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <Input
          placeholder="Search by Order ID, Customer or Address"
          prefix={<Search size={16} color="#94a3b8" />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 350, borderRadius: "8px" }}
          allowClear
          size="large"
        />
        <div>
          <Text type="secondary">
            Showing {filteredData.length} of {tableData.length} shipments
          </Text>
        </div>
      </div>

      {errorMessage && (
        <Alert
          type="error"
          message="Shipments load error"
          description={errorMessage}
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      {summary && (
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={24} md={12} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <Text style={{ color: "#64748b", fontSize: "14px" }}>
                Total Shipments
              </Text>
              <div
                style={{
                  marginTop: 8,
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#0f172a",
                }}
              >
                {summary.total_shipments}
              </div>
            </Card>
          </Col>
          <Col span={24} md={12} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <Text style={{ color: "#64748b", fontSize: "14px" }}>
                Total Items Shipped
              </Text>
              <div
                style={{
                  marginTop: 8,
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#8b5cf6",
                }}
              >
                {summary.total_items}
              </div>
            </Card>
          </Col>
          <Col span={24} md={12} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <Text style={{ color: "#64748b", fontSize: "14px" }}>
                Shipped
              </Text>
              <div
                style={{
                  marginTop: 8,
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#3b82f6",
                }}
              >
                {summary.shipped}
              </div>
            </Card>
          </Col>
          <Col span={24} md={12} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <Text style={{ color: "#64748b", fontSize: "14px" }}>
                Delivered
              </Text>
              <div
                style={{
                  marginTop: 8,
                  fontSize: 28,
                  fontWeight: 700,
                  color: "#10b981",
                }}
              >
                {summary.delivered}
              </div>
            </Card>
          </Col>
        </Row>
      )}

      <Table
        scroll={{ x: "max-content" }}
        columns={columns}
        dataSource={getCurrentPageData()}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: filteredData.length,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} shipments`,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "50", "100", "200"],
        }}
        onChange={handleTableChange}
        style={{
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          overflow: "hidden",
        }}
        className="reward-table-custom"
        rowClassName={() => "shipment-table-row"}
        locale={{ emptyText: errorMessage || "No shipments found" }}
        onRow={(record) => ({
          onClick: () => navigate(`/sales/shipments/${record.id}`),
        })}
      />

      {/* Shipment Details Modal - Keep the same */}
      <Modal
        title={
          <div>
            <Text strong style={{ fontSize: "18px" }}>
              Shipment Details
            </Text>
            <div
              style={{ fontSize: "14px", color: "#64748b", marginTop: "4px" }}
            >
              Order #{selectedShipment?.orderId}
            </div>
          </div>
        }
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setModalVisible(false)}>
            Close
          </Button>,
        ]}
        width={800}
      >
        {selectedShipment && (
          <div>
            <Row gutter={16} style={{ marginBottom: 24 }}>
              <Col span={12}>
                <Card size="small" title="Shipment Information">
                  <div>
                    <strong>SR No.:</strong> {selectedShipment.srNo}
                  </div>
                  <div>
                    <strong>Order ID:</strong> {selectedShipment.orderId}
                  </div>
                  <div>
                    <strong>Status:</strong>
                    <Tag
                      style={{
                        marginLeft: 8,
                        borderRadius: "12px",
                        background: getStatusColor(selectedShipment.status),
                        color: "#fff",
                        border: "none",
                      }}
                    >
                      {getStatusText(selectedShipment.status)}
                    </Tag>
                  </div>
                  <div>
                    <strong>Order Date:</strong> {selectedShipment.orderDate}
                  </div>
                  <div>
                    <strong>Shipment Date:</strong>{" "}
                    {selectedShipment.shipmentDate}
                  </div>
                  <div>
                    <strong>Total Quantity:</strong> {selectedShipment.quantity}{" "}
                    items
                  </div>
                  <div>
                    <strong>Inventory Source:</strong>{" "}
                    {selectedShipment.inventorySource}
                  </div>
                </Card>
              </Col>
              <Col span={12}>
                <Card size="small" title="Customer Information">
                  <div>
                    <strong>Name:</strong> {selectedShipment.shipmentTo}
                  </div>
                  <div>
                    <strong>Email:</strong> {selectedShipment.email}
                  </div>
                  {selectedShipment.phone && selectedShipment.phone !== "-" && (
                    <div>
                      <strong>Phone:</strong> {selectedShipment.phone}
                    </div>
                  )}
                </Card>
              </Col>
            </Row>

            <Card
              size="small"
              title="Shipping Address"
              style={{ marginBottom: 24 }}
            >
              <div>{selectedShipment.shippingAddress?.line1 || "N/A"}</div>
              {selectedShipment.shippingAddress?.line2 && (
                <div>{selectedShipment.shippingAddress.line2}</div>
              )}
              <div>
                {selectedShipment.shippingAddress?.city &&
                  `${selectedShipment.shippingAddress.city}, `}
                {selectedShipment.shippingAddress?.state &&
                  `${selectedShipment.shippingAddress.state} `}
                {selectedShipment.shippingAddress?.zipcode}
              </div>
              <div>{selectedShipment.shippingAddress?.country || "N/A"}</div>
            </Card>

            {selectedShipment.trackingNumber !== "-" && (
              <Card
                size="small"
                title="Tracking Information"
                style={{ marginBottom: 24 }}
              >
                <div>
                  <strong>Tracking Number:</strong>{" "}
                  {selectedShipment.trackingNumber}
                </div>
                <div>
                  <strong>Carrier:</strong> {selectedShipment.carrier}
                </div>
              </Card>
            )}

            <Card size="small" title="Items in Shipment">
              <Table
                dataSource={selectedShipment.items}
                pagination={false}
                size="small"
                columns={[
                  {
                    title: "SR No.",
                    key: "srNo",
                    width: 70,
                    render: (_, __, index) => index + 1,
                  },
                  {
                    title: "Product Name",
                    dataIndex: "product_name",
                    key: "product_name",
                    render: (text, record) =>
                      text || record.product?.name || record.name || "Product",
                  },
                  {
                    title: "Quantity",
                    dataIndex: "quantity",
                    key: "quantity",
                    width: 100,
                    align: "center",
                  },
                  {
                    title: "Unit Price",
                    dataIndex: "price",
                    key: "price",
                    width: 120,
                    align: "right",
                    render: (price) =>
                      price ? `${parseFloat(price).toFixed(2)} pts` : "-",
                  },
                ]}
                rowKey="id"
              />
            </Card>
          </div>
        )}
      </Modal>

      <style jsx>{`
        .shipment-table-row {
          cursor: pointer;
          transition: background 0.3s;
        }
        .shipment-table-row:hover {
          background: #f8fafc;
        }
      `}</style>
    </div>
  );
};

export default Shipments;
